import { render } from "./ProcessPageList.vue?vue&type=template&id=57084a92&scoped=true"
import script from "./ProcessPageList.vue?vue&type=script&lang=ts"
export * from "./ProcessPageList.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-57084a92"

export default script